var acordeon = function (selector, unico) {
    if (unico === void 0) { unico = true; }
    var contenedor = typeof selector === 'string' ? document.querySelector(selector) : selector;
    if (!contenedor) {
        return;
    }
    var botones = [].slice.call(contenedor.querySelectorAll('[aria-controls]')), paneles = botones.map(function (boton) { return contenedor.querySelector('#' + boton.getAttribute('aria-controls')); }), moviendo = false;
    var pliega = function (posicion) {
        var panel = paneles[posicion], boton = botones[posicion];
        panel.style.height = panel.scrollHeight + 'px';
        moviendo = true;
        setTimeout(function () {
            panel.addEventListener('transitionend', function () {
                panel.hidden = true;
                moviendo = false;
                boton.setAttribute('aria-expanded', 'false');
            }, { once: true });
            panel.style.height = '0';
        }, 16);
    };
    var despliega = function (posicion) {
        var panel = paneles[posicion], boton = botones[posicion];
        moviendo = true;
        panel.hidden = false;
        panel.addEventListener('transitionend', function () {
            panel.style.height = 'auto';
            moviendo = false;
            boton.setAttribute('aria-expanded', 'true');
        }, { once: true });
        panel.style.height = panel.scrollHeight + 'px';
    };
    var cambiaPanel = function (posicion) {
        if (moviendo || posicion < 0) {
            return;
        }
        if (unico) {
            for (var i = 0; i < botones.length; i += 1) {
                if (i !== posicion) {
                    pliega(i);
                }
            }
            despliega(posicion);
            return;
        }
        if (paneles[posicion].hidden) {
            despliega(posicion);
        }
        else {
            pliega(posicion);
        }
    };
    contenedor.addEventListener('click', function (e) {
        var boton = e.target;
        if (!boton || boton.nodeName !== 'BUTTON') {
            return;
        }
        cambiaPanel(botones.indexOf(boton));
    });
    contenedor.addEventListener('keydown', function (e) {
        var boton = e.target;
        if (!boton || boton.nodeName !== 'BUTTON') {
            return;
        }
        switch (e.key) {
            case 'Enter':
                cambiaPanel(botones.indexOf(boton));
                e.preventDefault();
                break;
            case 'Space': {
                cambiaPanel(botones.indexOf(boton));
                break;
            }
            case 'ArrowDown': {
                var siguiente = (botones.indexOf(boton) + 1) % botones.length;
                botones[siguiente].focus();
                e.preventDefault();
                break;
            }
            case 'ArrowUp': {
                var posicion = botones.indexOf(boton), siguiente = posicion === 0 ? botones.length - 1 : posicion - 1;
                botones[siguiente].focus();
                e.preventDefault();
                break;
            }
            case 'Home': {
                botones[0].focus();
                e.preventDefault();
                break;
            }
            case 'End': {
                botones[botones.length - 1].focus();
                e.preventDefault();
                break;
            }
        }
    }, true);
    return {
        actualiza: function () {
            botones = [].slice.call(contenedor.querySelectorAll('[aria-controls]'));
            paneles = botones.map(function (boton) { return document.getElementById(boton.getAttribute('aria-controls')); });
        }
    };
};
export default acordeon;
